// ArChat Auto-Normalized File
// Author: SIVOL - Aldo Frias - Argentina

/**
 * BUILD_ID: fuente de verdad = meta tag <meta name="build-id"> inyectado en index.html.
 * Fallback: constante compilada por Vite (__BUILD_ID__ desde shared/build_id.txt).
 * El meta tag es post-procesado por inject-build-id-local.mjs tras el build,
 * por lo que siempre refleja el BUILD definitivo.
 * @file frontend/src/config/buildInfo.js
 */

function resolveBuildId() {
  if (typeof document !== 'undefined') {
    const meta = document.querySelector('meta[name="build-id"]');
    if (meta?.content) return meta.content;
  }
  return String(__BUILD_ID__);
}

export const BUILD_ID = resolveBuildId();
export const BUILD_TIME = new Date().toISOString()
